(()=>{
  if(window.__purePindComboDedupeV18)return;
  window.__purePindComboDedupeV18=true;

  const STORIES={
    'everyday-protein-trio':{
      title:'Protein, without making every meal a project.',
      copy:'This bundle is built for households that want protein to show up across the day without relying on one format. Keep the routine familiar, keep the pantry flexible, and make one order do more work.',
      best:'Best for fitness-conscious households that want a practical protein-forward pantry.'
    },
    'sugar-smart-kitchen-kit':{
      title:'A more considered pantry, without changing how home food feels.',
      copy:'The point of this bundle is convenience: one order for a thoughtfully chosen everyday pantry set, so you can keep familiar Indian meals at the centre of the routine instead of turning food into a complicated programme.',
      best:'Best for health-conscious and glucose-conscious households looking for a fibre-forward everyday pantry.'
    },
    'lighter-everyday-bundle':{
      title:'More variety on the plate. Less effort in the pantry.',
      copy:'This bundle brings together fibre-forward everyday staples so you can rotate meals and textures without separately planning multiple pantry purchases. It is designed around practical Indian home cooking, not diet-food theatre.',
      best:'Best for households that want more grain variety and a fibre-forward everyday routine.'
    },
    'daily-flour-starter-box':{
      title:'A pantry that earns its space.',
      copy:'This starter box is designed to make the first PurePind pantry easy: one order, several everyday cooking possibilities, and fewer separate buying decisions. The value is not just the discount—it is having more useful options ready when the next meal is decided.',
      best:'Best for families who want an easy first step beyond using only one everyday flour.'
    }
  };

  const handle=()=>{
    const match=location.pathname.match(/\/products\/([^/?#]+)/);
    return match?decodeURIComponent(match[1]):'';
  };

  function cleanComboPage(){
    const config=STORIES[handle()];
    if(!config)return;
    const page=document.querySelector('[data-pp-product-page]');
    if(!page||page.dataset.ppComboDedupeV18==='true')return;
    page.dataset.ppComboDedupeV18='true';

    const story=page.querySelector('.pp-editorial-story .pp-editorial-copy');
    if(story){
      const eyebrow=story.querySelector('.pp-eyebrow');
      const heading=story.querySelector('h2');
      const rich=story.querySelector('.pp-richtext');
      if(eyebrow)eyebrow.textContent='Why this bundle exists';
      if(heading)heading.innerHTML=config.title;
      if(rich)rich.innerHTML=`<p>${config.copy}</p><p><strong>${config.best}</strong></p>`;
    }

    const details=page.querySelector('.pp-product-details');
    if(details){
      details.innerHTML=`
        <div>
          <p class="pp-eyebrow">Buying the bundle</p>
          <h2>Good to know.<br><em>Before you order.</em></h2>
        </div>
        <div class="pp-detail-accordions">
          <details open>
            <summary>How this bundle works</summary>
            <div class="pp-richtext"><p>This is sold as one PurePind bundle at the current bundle price. Each included product remains individually packed and labelled. The exact products, pack sizes and individual prices are shown once in the “what’s inside” section above.</p></div>
          </details>
          <details>
            <summary>How the savings are calculated</summary>
            <div class="pp-richtext"><p>“Buy separately” is based on the current individual selling prices of the included pack sizes. “Bundle price” is the current combo selling price. The displayed saving can change if individual or bundle prices are updated.</p></div>
          </details>
          <details>
            <summary>Ingredients, nutrition and allergens</summary>
            <div class="pp-richtext"><p>Each included product has its own ingredient, nutrition, allergen, preparation, storage and best-before information. Use the “View full product” links in the section above or read the individual pouch before use.</p></div>
          </details>
          <details>
            <summary>Delivery, COD and returns</summary>
            <div class="pp-richtext"><p>₹79 shipping below ₹799 and free shipping from ₹799. Full COD is available, so you can pay the order amount on delivery. Choose prepaid online payment to receive 5% off.</p><p><a href="/policies/shipping-policy">Shipping policy</a> · <a href="/policies/refund-policy">Refund policy</a></p></div>
          </details>
        </div>`;
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',cleanComboPage);else cleanComboPage();
})();
